import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SelectableCardList } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { IS_EMAIL_SUPPORTED_ENABLED } from '@bingads-webui-campaign-react/conversion-utils';
import { optionSelectorClasses } from '../styles/edit-website-view-styles';

export const OptionsSelectableCardList = (props) => {
  const {
    onChangeOptions,
    isEmailSupported,
    isGTMEnabled,
    selectedOption,
  } = props;

  const i18n = useContext(I18nContext);
  const overwriteClasses = useDefaultStyles(optionSelectorClasses);

  const options = {
    thirdPartyTag: {
      id: 'thirdPartyTag',
      title: i18n.getString(_TL_('Add the tag through a website editing platform')),
      description: i18n.getString(_TL_('We\'ll provide instructions for adding the tracking tag through an editing platform, such as WordPress, Wix, Shopify, or BigCommerce.')),
      glyphIconName: 'ba-AdUnitChannel',
    },
    googleTagManager: {
      id: 'googleTagManager',
      title: i18n.getString(_TL_('Automatically add the tracking tag through Google Tag Manager')),
      description: i18n.getString(_TL_('If you are already using Google Tag Manager for your website, we can automatically set up the tracking tag for you.')),
      glyphIconName: 'ba-AdUnitChannel',
    },
    copyTag: {
      id: 'copyTag',
      title: i18n.getString(_TL_('Install the tag yourself')),
      description: i18n.getString(_TL_('We\'ll provide instructions so you can add the tracking tag to your website\'s code.')),
      iconName: 'SingleColumnEdit',
    },
    emailTag: {
      id: 'emailTag',
      title: i18n.getString(_TL_('Send the tag to a developer')),
      description: i18n.getString(_TL_('We\'ll send the tracking tag and instructions to the people you specify, so they can add the tag to your website\'s code.')),
      iconName: 'Mail',
    },
  };


  const optionStrings = useMemo(() => {
    const methods = [options.copyTag];

    if (isEmailSupported) {
      methods.push(options.emailTag);
    }

    methods.push(options.thirdPartyTag);

    if (isGTMEnabled) {
      methods.push(options.googleTagManager);
    }
    return methods;
  }, [isEmailSupported, isGTMEnabled, options.copyTag, options.emailTag, options.googleTagManager, options.thirdPartyTag]);

  return (
    <div className="edit-website-options">
      <SelectableCardList
        className="edit-website-options-list"
        contents={optionStrings}
        onItemSelected={onChangeOptions}
        selectedItem={selectedOption}
        useLargeCards
        classes={overwriteClasses}
      />
    </div>
  );
};


OptionsSelectableCardList.propTypes = {
  onChangeOptions: PropTypes.func.isRequired,
  isEmailSupported: PropTypes.bool,
  isGTMEnabled: PropTypes.bool.isRequired,
  selectedOption: PropTypes.string,
};

OptionsSelectableCardList.defaultProps = {
  isEmailSupported: IS_EMAIL_SUPPORTED_ENABLED,
  selectedOption: undefined,
};
